<template>
  <div class="wrap">
    <!-- <div class="left">
      <div class="title">
        <span class="count">设备总数</span>
        <span>xxxx</span>
      </div>
      <div class="message-wrap">
        <div class="message">
          <el-row class="top">
            <el-col :span="12">设备名称xxx</el-col>
            <el-col :span="12" class="num">xxxx</el-col>
          </el-row>
          <el-row class="detail">
            <el-col :span="11" v-for="(val, key, index) in detailData" :key="index" :offset="2">
              <el-col :span="6">{{key}}</el-col>
              <el-col :span="6" class="num" >{{val}}台</el-col>
            </el-col>
          </el-row>
        </div>
      </div>
    </div> -->
    <div class="right">
      <div class="echart-wrap">

        <div class="title">
          <div class="name">
            <span style="margin-right:20px">{{title}}</span>
            <el-switch
              v-model="showLineChart"
              active-text="折线图"
              inactive-text="条形图">
            </el-switch>
            <!-- <el-tag class="tag">统计函数-{{performTypeList[taskDetail.performType]}}</el-tag> -->
            <el-tag  class="tag">产品名称-{{taskDetail.productName}}</el-tag>
          </div>

          <!-- 时间选择 -->
          <div class="function-wrap">
            <el-button type="" icon="el-icon-document" @click="exportData" :disabled="!hasData || loading" :loading="loading">{{loading?'导出中':'导出表格'}}</el-button>
            <div class="dateWrap">
              <el-date-picker
                v-model="showDate"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                change="changeDate"
                clearable
                align="right">
              </el-date-picker>
            </div>
            <!-- 年月切换 -->
            <el-button-group>
              <el-button @click="periodClick(3)" :type="initQueryParams.params.period === 3 ? 'primary':''">月</el-button>
              <el-button @click="periodClick(2)" :type="initQueryParams.params.period === 2 ? 'primary':''">日</el-button>
              <el-button @click="periodClick(1)" :type="initQueryParams.params.period === 1 ? 'primary':''">时</el-button>
              <el-button @click="periodClick(0)" :type="initQueryParams.params.period === 0 ? 'primary':''">分</el-button>
            </el-button-group>
          </div>
        </div>
        <div class="echart">
          <SiderCharts
            :productName="taskDetail.productName"
            :title="title"
            :centerTitle="performTypeList[taskDetail.performType]"
            :unitName="groupName.unitName"
            @next-page="nexPage"
            v-if="chartData && showLineChart"
            :refresh="refresh"
            :data="chartData"/>
          <BarCharts
          :productName="taskDetail.productName"
            :title="title"
            :centerTitle="performTypeList[taskDetail.performType]"
            :unitName="groupName.unitName"
            @next-page="nexPage" v-if="chartData && !showLineChart"
            :refresh="refresh"
            :data="chartData"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SiderCharts from './lineCharts.vue'
import BarCharts from './barCharts'
import { dateHelper, dataFormat, loadFileByUrl } from '@/utils'

// import helper from '@/utils/helper.js'
import { eventBus } from '@/utils/eventBus'
import { mapData, exportDataFile } from '@/api/dataStatistics'
import { thingModel } from '@/api/deviceManagement'

export default {
  props: ['taskId', 'taskDetail', 'centerTitle'],
  components: {
    SiderCharts,
    BarCharts
  },
  data () {
    return {
      loading: false, // 表示是否正正在导出表格
      detailData: {
        online: '27',
        a1asdas: '0',
        basdsa: '0',
        csadsa: '0'
      },
      test: {
        aa: 88,
        bb: 77
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }],
        disabledDate (time) {
          // 限制一年
          const dateArr = dateHelper.getRecentYear('number')
          return (time.getTime() > dateArr[1] || time.getTime() < dateArr[0] - 8.64e6)
        }
      },
      dateParams: {
        beginTime: '',
        endTime: '',
        period: '' // 默认为2按日展示、3按月展示
      },
      showDate: ['', ''],
      // 切换tab的初始请求参数，不改动，除了taskId，其他不动
      // 然后每个子组件维护自己的相应的请求参数的变动，将请求参数带过来
      initQueryParams: {
        params: {
          taskId: this.taskId,
          beginTime: '',
          endTime: '',
          // period 和way的对应
          // 3 2 1 0
          //   1 2 3
          period: this.taskDetail.way !== '' && !isNaN(this.taskDetail.way)
            ? this.taskDetail.way === 1
              ? 2
              : this.taskDetail.way === 2
                ? 1
                : 0
            : 3, // this.taskDetail.way !== '' && !isNaN(this.taskDetail.way) ? this.taskDetail.way : 2, // 2按日// period为3默认按月汇总
          pageNumber: 1,
          pageSize: 1440
        }
      },
      chartData: null, // 用于绘制图表数
      propertyData: {}, // 用于保存各个不同属性对应得图表数据
      total: 0,
      isRequest: false,
      showLineChart: true,
      refresh: false, // 用于请求完数据刷新图表
      thingModel: null, // 物模型数据
      title: '',
      groupName: '', // 用于保存分组名
      // 统计函数列表
      performTypeList: {
        0: '总数',
        1: '最大值',
        2: '最小值',
        3: '求和',
        4: '平均'
      }
    }
  },
  created () {
    const dateArr = dateHelper.getRecentWeek()
    this.showDate = [dateArr[0], dateArr[1]]
    // 获取物模型数据
    this.getThingModel()
    // this.initMapData()
  },
  methods: {
    getGroupItem (field) {
      console.log('调用了getGroupItem')
      // 获取分组对象
      const typeList = {
        1: 'properties',
        2: 'events',
        3: 'services'
      }
      let list = ''
      if (this.taskDetail.type.toString() === '1') { // 属性
        list = this.thingModel[typeList[this.taskDetail.type]]
      } else {
        list = this.thingModel[typeList[this.taskDetail.type]].outputData
      }
      console.log('list:', list)
      console.log('this.taskDetail:', this.taskDetail)
      let fieldList
      if (field) {
        fieldList = field.split('.')
      } else {
        fieldList = this.taskDetail.field.split('.')
      }
      const getItem = function (index, list) {
        let item = ''
        let i = 0
        while (i < list.length) {
          if (list[i].identifier === fieldList[index]) {
            item = list[i]
            console.log('找到了item：', item)
            if (index < fieldList.length && item.dataType.type === 'struct') {
              getItem(index++, item.dataType.specs)
            } else if (index < fieldList.length && item.dataType.type === 'array') {
              if (item.dataType.specs.item.type === 'struct') {
                getItem(index++, item.dataType.specs.item.specs)
              } else {
                console.log(88888)
                return item
                // return item.dataType.specs
              }
            } else {
              console.log(88888)
              return item
              // return item.dataType.specs
            }
            break
          }
          i++
        }
      }
      const groupName = getItem(0, list)
      console.log('获取的groupName：', groupName)
      return groupName
    },
    getThingModel (pieChartData) {
      const params = {
        productKey: this.taskDetail.productKey
      }
      console.log('getThingModel params:', params)
      thingModel(params).then(res => {
        res = res.data
        console.log('外层物模型数据：', res)
        this.thingModel = res.data.thingModel
        const groupItem = this.getGroupItem()
        this.title = groupItem.name
        this.groupName = groupItem.dataType.specs
        console.log('groupName:', this.groupName)
      }).catch(() => {

      })
      console.log('await后面')
    },
    changeDate (date) {
      console.log('获取的数据：', date)
    },
    periodClick (period) {
      this.initQueryParams.params.pageNumber = 1
      this.initQueryParams.params.period = period
      const params = this.initQueryParams
      this.showDate = ['', '']
      this.getMapData(params)
      // this.dateParams.period = period
      // eventBus.$emit('query-chart-data', { params: this.dateParams })
    },
    exportData () {
      this.initQueryParams.params.beginTime = dataFormat(this.showDate[0])
      this.initQueryParams.params.endTime = dataFormat(this.showDate[1])
      const params = this.initQueryParams.params
      this.loading = true
      // const that = this
      setTimeout(function () {
        this.loading = false
      }, 10000)
      exportDataFile(params).then(res => {
        res = res.data
        console.log('返回的下载数据：', res)
        if (res.data) {
          // window.open(res.data)
          loadFileByUrl(res.data)
        } else {
          this.$message.error('下载出错')
        }
        this.loading = false
      })
    },
    initMapData () {
      this.initQueryParams.params.pageNumber = 1// 每次请求页码重置为1
      this.initQueryParams.params.beginTime = dataFormat(this.showDate[0])
      this.initQueryParams.params.endTime = dataFormat(this.showDate[1])
      const params = this.initQueryParams
      console.log('获取的params：', JSON.stringify(params))
      this.getMapData(params)
    },
    // 获取折线图和条形图数据
    getMapData (params, nextPage) {
      if (this.isRequest) {
        return
      }
      if (!nextPage) {
        this.propertyData = {}
      }
      this.isRequest = true
      console.log('获取折线图和条形图数据:params:', JSON.stringify(params))
      const chartData = nextPage ? this.chartData : { xData: [], yData: [] }
      const that = this
      // 获取返回数据后的回调函数
      const callBack = function (res) {
        that.isRequest = false
        if (res.data.data) {
          console.log('请求的params', params)
          console.log('返回数据：', res.data)
          console.log('params.params.pageNumber:', params.params.pageNumber)
          let total = 0
          const record = res.data.data.list ? res.data.data.list : []
          record.forEach((propertyItem, index) => {
            if (!propertyItem) {
              return
            }
            propertyItem.recordCount > total ? total = propertyItem.recordCount : ''// 取最大的total
            const groupName = that.getGroupItem(propertyItem.identifier)

            !that.propertyData[propertyItem.identifier] ? that.propertyData[propertyItem.identifier] = {
              xData: [],
              x2y: {},
              ySortData: [],
              groupName: groupName,
              performType: that.performTypeList[propertyItem.performType]
            } : ''
            // 用于保存每个属性对应每页的数据，方便往头部插入数据
            const pageCharData = {
              xData: [],
              yData: []
            }
            propertyItem.recordLists.forEach((item, index) => {
              // 数据先给最后一页的数据
              // 上一页第一条数据，可能与下一页的最后一条数据是同一个时间的，需要做比对处理处理
              // const len = chartData.xData.length
              if (index === propertyItem.recordLists.length - 1 && chartData.xData.length > 0 && chartData.xData[0] === item.recordTime) {
                // 有重复日期的天数
                // xData不需要push，修改yData的数据
                const startValue = parseFloat(chartData.yData[0])
                let targetValue
                if (item.performType === 0 || item.performType === 3) { // 总数或者求和函数，累加
                  targetValue = startValue + item.count
                } else if (item.performType === 1) { // 最大值函数，取最大
                  targetValue = startValue > item.count ? startValue : item.count
                } else if (item.performType === 2) { // 最小值函数，取最小
                  targetValue = startValue < item.count ? startValue : item.count
                } else if (item.performType === 4) { // 平均函数，取两数平均值
                  targetValue = (startValue + item.count) / 2
                }
                // that.propertyData[propertyItem.identifier].yData[0] = targetValue
                that.propertyData[propertyItem.identifier].x2y[dataFormat(item.recordTime)] = targetValue
                // chartData.yData[0] = targetValue
              } else {
                pageCharData.xData.push(dataFormat(item.recordTime))
                that.propertyData[propertyItem.identifier].x2y[dataFormat(item.recordTime)] = item.count
                // chartData.xData.unshift(dataFormat(item.recordTime))
                // chartData.yData.unshift(item.count)
              }
            })
            // 往头部追加数据，xData后面再做去重处理
            that.propertyData[propertyItem.identifier].xData.unshift(...pageCharData.xData)
          })
          that.total = total
          that.sortData()// 整理数组，去重复

          // record.forEach((item, index) => {
          //   // 数据先给最后一页的数据
          //   // 上一页第一条数据，可能与下一页的最后一条数据是同一个时间的，需要做比对处理处理
          //   // const len = chartData.xData.length
          //   if (index === record.length - 1 && chartData.xData.length > 0 && chartData.xData[0] === item.recordTime) {
          //     // 有重复日期的天数
          //     // xData不需要push，修改yData的数据
          //     const endValue = parseFloat(chartData.yData[0])
          //     let targetValue
          //     if (this.taskDetail.performType === 0 || this.taskDetail.performType === 3) { // 总数或者求和函数，累加
          //       targetValue = endValue + item.count
          //     } else if (this.taskDetail.performType === 1) { // 最大值函数，取最大
          //       targetValue = endValue > item.count ? endValue : item.count
          //     } else if (this.taskDetail.performType === 2) { // 最小值函数，取最小
          //       targetValue = endValue < item.count ? endValue : item.count
          //     } else if (this.taskDetail.performType === 4) { // 平均函数，取两数平均值
          //       targetValue = (endValue + item.count) / 2
          //     }
          //     chartData.yData[0] = targetValue
          //   } else {
          //     pageCharData.xData.push(dataFormat(item.recordTime))
          //     pageCharData.yData.push(item.count)
          //     // chartData.xData.unshift(dataFormat(item.recordTime))
          //     // chartData.yData.unshift(item.count)
          //   }
          // })

          // // 往头部追加数据
          // chartData.xData.unshift(...pageCharData.xData)
          // chartData.yData.unshift(...pageCharData.yData)
          // // for循环之后，统计完毕
          // console.log('chartData数据为：', chartData)
          // that.chartData = chartData
          // 不管数据有没变化（去重可能导致数据没变化），都调用子组件重新绘制图表
          // 调整到滚轮有空隙可以滚动
          // that.$nextTick().then(function () {
          //   eventBus.$emit('refresh-chart')
          // })
          // that.refresh = !that.refresh
        }
      }
      const getData = function () {
        console.log('发送请求的params:', params)
        mapData(params).then(callBack)
      }
      getData()
    },
    sortData () {
      let xData = new Set()
      console.log('sorDATA-this.propertyData:', this.propertyData)
      Object.keys(this.propertyData).forEach(key => {
        // xData.add(...this.compareTask[key].chartData.xData)
        xData = new Set([...xData, ...this.propertyData[key].xData])
      })
      xData = [...xData]
      // 大大小排序时间
      xData.sort((a, b) => {
        return new Date(a).getTime() - new Date(b).getTime()
      })
      // console.log('xData:', xData)
      const that = this
      // 从新给yData赋值
      xData.forEach(timeKey => {
        Object.keys(that.propertyData).forEach(key => {
          const value = that.propertyData[key].x2y[timeKey]
          if (value || !isNaN(value)) {
            that.propertyData[key].ySortData.push(value)
          } else {
            that.propertyData[key].ySortData.push('')
          }
        })
      })
      // 组装成图表需要得数据
      const chartData = { xData: xData, series: [], barSeries: [] }
      Object.keys(that.propertyData).forEach(key => {
        const yData = that.propertyData[key].ySortData
        const name = that.propertyData[key].groupName.name + '-' + that.propertyData[key].performType
        const item = {
          name: name,
          type: 'line',
          data: yData
        }
        const barItem = {
          name: name,
          type: 'bar',
          data: yData
        }
        chartData.series.push(item)
        chartData.barSeries.push(barItem)
      })
      // Object.assign(this.chartData, chartData)

      this.chartData = chartData
      console.log('this.chartData:', this.chartData)
      this.refresh = !this.refresh
    },
    nexPage () {
      console.log('this.total:', this.total)
      if (this.initQueryParams.params.pageNumber < (this.total / this.initQueryParams.params.pageSize)) {
        console.log('this.isRequest:', this.isRequest)
        if (this.isRequest === true) {
          return
        }
        this.initQueryParams.params.pageNumber++
        const params = this.initQueryParams
        this.getMapData(params, true)
      }
    }
  },
  computed: {
    hasData () {
      return (this.chartData && this.chartData.xData && this.chartData.xData.length > 0)
    }
  },
  watch: {
    showDate () {
      console.log('this.showDate变化了:', this.showDate)
      // 监听到日期变化后，去重新请求数据
      if (this.showDate) { // 点击清除按钮时候绑定的dateSel为null
        this.initQueryParams.params.pageNumber = 1// 每次请求页码重置为1
        this.initQueryParams.params.beginTime = dataFormat(this.showDate[0])
        this.initQueryParams.params.endTime = dataFormat(this.showDate[1])
        const params = this.initQueryParams
        this.getMapData(params)
        // eventBus.$emit('query-chart-data', { params: this.dateParams, data: this.data })
      }
    },
    'dateParams.period' () {
      console.log('period变化了')
      eventBus.$emit('query-chart-data', { dateParams: this.dateParams, data: this.data })
    },
    taskId () {
      console.log('taskId变换了：', this.taskId)
    }

  }
}
</script>

<style lang='less' scoped>
  .el-col-11{
    display: flex;
    justify-content: space-between;
  }
  .el-col-offset-2:nth-child(2n+1){
    margin-left: 0 !important;
  }
  .wrap{
    display: flex;
    justify-content: space-between;
    height: 600px;
    .left{
      background: #D5D5D5;
      width: 24%;
      border: 1px solid#F7F7F7;
      .title{
        display: flex;
        font-size: 20px;
        padding: 0 10px;
        justify-content: space-between;
        line-height: 50px;
        border-bottom: 1px solid#F7F7F7;;
      }
      .message-wrap{
        padding: 15px 10px;
        .message{
          padding: 15px 10px;
          background: white;
          .top{
            margin-bottom: 20px;
            .num{
              text-align: right;
            }
          }
          .detail{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .num{
              text-align: right;
            }
          }
        }
      }
    }
    .right{
      // background: #D5D5D5;
     // width: 75.4%;
      // border: 1px solid#F7F7F7;
      width:100%;
      padding: 20px 0px 0px 10px;
      .echart-wrap{
        background: white;
        height: 540px;
        // overflow: hidden;
        .title{
          padding: 10px 10px 0;
          font-size: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .function-wrap{
            display: flex;
            justify-content: space-between;
            .dateWrap{
              margin-right: 20px;
              margin-left: 20px;
            }
          }
        }
        .echart{
          padding-top: 20px;
          height: 450px;
          width: 100%;
        }
      }
    }
    .tag{
      margin-left: 10px;
    }
  }
</style>
